module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', {
    staticClass: "coupon-container"
  }, [_c('c-navbar', {
    attrs: {
      "title": "领取成功"
    }
  }), _vm._v(" "), _c('c-content', [_c('div', {
    staticClass: "coupon-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "desc-title"
  }, [_vm._v("518元旺铺券已放入您的账户中")]), _vm._v(" "), _c('div', {
    staticClass: "desc-sub-title"
  }, [_vm._v("礼金券有效期为2018.5.18~5.22")]), _vm._v(" "), _c('div', {
    staticClass: "desc-remind"
  }, [_vm._v("* 部分礼金券请至生意专家电脑端使用")])]), _vm._v(" "), _c('c-images', {
    attrs: {
      "img-items": _vm.images
    }
  })], 1)]), _vm._v(" "), _c('c-footer', {
    staticClass: "bg-color gray",
    staticStyle: {
      "border-color": "transparent"
    }
  }, [_c('c-button', {
    staticStyle: {
      "background-color": "#F5A623",
      "border-color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToCoupon($event)
      }
    }
  }, [_vm._v("查看我的券\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e372306","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tabs/2018-05-18/coupon/index.vue
// module id = 1029
// module chunks = 2